import {
  FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL,
  FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL_FINISHED,
  FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST,
  FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_SUCCESS,
  FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_FAILURE,
  IMPORTING_GL_ACCOUNT_LIST,
  IMPORTING_GL_ACCOUNT_LIST_SUCCESS,
  IMPORTING_GL_ACCOUNT_LIST_FAILURE,
} from './types';

import { fetchAccounts as fetchAccountsApi } from '../../../shared/api';

import {
  importGlAccountsLists as importGlAccountsListsApi,
} from '../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification } from '../../../shared/store/notificationActions';

import agGridConfig from '../../../agGridConfig';
import getApi from '../../shared/apiFactory';
import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import Config from '../../../config';
import { FIELD_MAPPINGS, MIN_COLUMNS_NUMBER, MAX_COLUMNS_NUMBER } from '../xlsxImport/constants';
import columnHeaders from '../xlsxImport/columnHeaders';
import { normalizeCellToString } from '../../../utils/readXlsxFile.utils';

export const sharedActions = getActions(
  adminPageNames.GL_ACCOUNT_LIST,
  {
    pageTitle: adminPageTitles.GL_ACCOUNT_LIST,
    api: getApi({
      pageTitle: adminPageTitles.GL_ACCOUNT_LIST,
      endpoints: {
        FETCH: Config.endpoints.FETCH_GL_ACCOUNT_LIST,
        INSERT: Config.endpoints.INSERT_GL_ACCOUNT_LIST,
        UPDATE: Config.endpoints.UPDATE_GL_ACCOUNT_LIST,
        DELETE: Config.endpoints.DELETE_GL_ACCOUNT_LIST,
        VALIDATE: Config.endpoints.VALIDATE_GL_ACCOUNT_LIST,
        IMPORT: Config.endpoints.IMPORT_GL_ACCOUNT_LIST,
      },
    }),
    sortingField: 'glAccount',
    agGridConfig: agGridConfig.adminGlAccountList,
    excel: {
      sheetName: 'GL Account List',
      lastColumnLetter: 'C',
      columnHeaders,
      fieldMappings: FIELD_MAPPINGS,
      minColumnsNumber: MIN_COLUMNS_NUMBER,
      maxColumnsNumber: MAX_COLUMNS_NUMBER,
      fieldNormalizers: {
        period: normalizeCellToString,
        listname: normalizeCellToString,
        glaccount: normalizeCellToString,
      },
    },

  }
);

export const importGLAccountList = (GLAccountLists, periodName) => async dispatch => {
  dispatch({
    type: IMPORTING_GL_ACCOUNT_LIST,
  });
  try {
    await importGlAccountsListsApi(GLAccountLists, periodName);
    dispatch({
      type: IMPORTING_GL_ACCOUNT_LIST_SUCCESS,
    });
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: IMPORTING_GL_ACCOUNT_LIST_FAILURE,
    });
  }
};

export const fetchAccounts = () => async dispatch => {
  dispatch({
    type: FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST,
  });
  try {
    const response = await fetchAccountsApi();

    return dispatch({
      type: FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_SUCCESS,
      accounts: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchInitialDataForGLAccountListAddEditModal = () => async dispatch => {
  dispatch({
    type: FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL,
  });

  await dispatch(fetchAccounts());

  dispatch({
    type: FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL_FINISHED,
  });
};
